import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs";

/** Terrible Side Effects because we can't fix news properly yet */
export class NewsSessionIdStore {

    public static readonly id = "newsSessionIdStore";

    private readonly current$ = new BehaviorSubject<string | null>(null);

    public get current(): Observable<string| null> {
        return this.current$.asObservable();
    }

    public update(id: string) {
        this.current$.next(id);
    }
}
